import { useCallback } from 'react'

import { PaginatedCompanyGroupsDocument, TagsSettingsDocument, useCreateTagMutation } from '~generated/hooks'
import { CreateTagInput } from '~generated/types'

export interface CreateTagData extends CreateTagInput {
  onCompleted?: (id: string) => void
}

export default function useCreateTag() {
  const [createTagMutation, options] = useCreateTagMutation({
    notifyOnNetworkStatusChange: true,
    refetchQueries: [PaginatedCompanyGroupsDocument],
  })

  const createTag = useCallback(
    async ({ onCompleted, ...input }: CreateTagData) => {
      const response = await createTagMutation({
        variables: {
          input,
        },
        refetchQueries: () => [TagsSettingsDocument],
        update: (cache, { data: { createTag: tag } = {} }) => {
          if (!tag) return
          // TODO create shared handler
          cache.modify({
            id: 'ROOT_QUERY',
            fields: {
              tags: (cached, { storeFieldName, readField, toReference }) => {
                if (!storeFieldName.includes(tag.type)) return cached
                if (cached.some((ref) => readField('id', ref) === tag.id)) return cached

                return [...cached, toReference(tag)]
              },
            },
          })
        },
        onCompleted: ({ createTag }) => onCompleted?.(createTag.id),
      })

      return response?.data.createTag
    },
    [createTagMutation]
  )

  return [createTag, options] as const
}
